"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeOutlierByPercentile = exports.orderBy = exports.objectToSeries = exports.nestedObjectsToGroupedSeries = exports.groupedCountToPercent = exports.countToPercent = void 0;
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _sumBy = _interopRequireDefault(require("lodash/sumBy"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _isString = _interopRequireDefault(require("lodash/isString"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var objectToSeries = function objectToSeries(data) {
  return Object.entries(data).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return {
      k: k,
      v: v
    };
  });
};
exports.objectToSeries = objectToSeries;
var nestedObjectsToGroupedSeries = function nestedObjectsToGroupedSeries(data) {
  var dataInverted = {};
  Object.keys(data).forEach(function (k) {
    Object.keys(data[k]).forEach(function (k2) {
      if (!dataInverted[k2]) dataInverted[k2] = [];
      var item = {
        k: k,
        v: data[k][k2]
      };
      dataInverted[k2].push(item);
    });
  });
  return Object.keys(dataInverted).map(function (ki) {
    return {
      k: ki,
      v: dataInverted[ki]
    };
  });
};
exports.nestedObjectsToGroupedSeries = nestedObjectsToGroupedSeries;
var countToPercent = function countToPercent(data) {
  var total = data.map(function (e) {
    return e.v;
  }).reduce(function (a, b) {
    return a + b;
  }, 0);
  return data.map(function (e) {
    return {
      k: e.k,
      v: e.v / total
    };
  });
};
exports.countToPercent = countToPercent;
var groupedCountToPercent = function groupedCountToPercent(data) {
  var total = {};
  data.forEach(function (e) {
    e.v.forEach(function (e2) {
      total[e2.k] = (total[e2.k] || 0) + e2.v;
    });
  });
  return data.map(function (e) {
    return {
      k: e.k,
      v: e.v.map(function (e2) {
        return {
          k: e2.k,
          v: e2.v / total[e2.k]
        };
      })
    };
  });
};
exports.groupedCountToPercent = groupedCountToPercent;
var orderBy = function orderBy(data, order, orderGroup) {
  var sorter = (0, _isArray.default)(order) // sorted by provided order
  ? function (e) {
    var idx = order.indexOf(e.k);
    return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
  } : (0, _isFunction.default)(order) ? order : undefined;
  var dataSorted = (0, _sortBy.default)(data, sorter);
  // handle sorting of groups (order within a series)
  if (orderGroup) {
    if ((0, _isString.default)(orderGroup)) {
      if (orderGroup === "__total__") {
        // sort by total, special key "__total__" is used as the key for total to avoid collision with actual keys
        var sum = {};
        dataSorted.forEach(function (e) {
          return e.v.forEach(function (e2) {
            return sum[e2.k] = (sum[e2.k] || 0) + (e2.v || 0);
          });
        });
        orderGroup = (0, _sortBy.default)(Object.entries(sum), function (s) {
          return -s[1];
        }).map(function (s) {
          return s[0];
        });
      } else {
        // sort by the value of certain key
        var vals = dataSorted.filter(function (e) {
          return e.k === orderGroup;
        });
        orderGroup = vals && vals.length > 0 ? (0, _sortBy.default)(vals[0].v, function (e) {
          return -e.v || 0;
        }).map(function (e) {
          return e.k;
        }) : undefined;
      }
    }
    var sorterInner = (0, _isArray.default)(orderGroup) // sorted by provided order
    ? function (e2) {
      var idx = orderGroup.indexOf(e2.k);
      return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
    } : (0, _isFunction.default)(orderGroup) ? orderGroup : undefined;
    dataSorted = dataSorted.map(function (e) {
      return {
        k: e.k,
        v: (0, _sortBy.default)(e.v, sorterInner)
      };
    });
  }
  return dataSorted;
};
exports.orderBy = orderBy;
var removeOutlierByPercentile = function removeOutlierByPercentile(data, percentile) {
  if (data.length === 0) {
    return [];
  }
  var convertData = function convertData(data) {
    var res = {};
    data.forEach(function (e) {
      e.v.forEach(function (e2) {
        if (!res[e2.k]) res[e2.k] = [];
        res[e2.k].push({
          k: e.k,
          v: e2.v
        });
      });
    });
    return res;
  };
  var filterData = function filterData(data) {
    var getCount = function getCount(d) {
      return (0, _isArray.default)(d.v) ? (0, _sumBy.default)(d.v, "v") : d.v;
    };
    var cumulativeSum = [getCount(data[0])];
    for (var i = 1; i < data.length; i++) {
      cumulativeSum[i] = getCount(data[i]) + cumulativeSum[i - 1];
    }
    var total = cumulativeSum[data.length - 1];
    var cutLow = (100 - percentile) / 200 * total;
    var cutHigh = total - cutLow;
    var cutLeft = 0;
    var cutRight = data.length;
    for (var _i2 = 0; _i2 < data.length; _i2++) {
      cutLeft = _i2;
      if (cumulativeSum[_i2] > cutLow) break;
    }
    for (var _i3 = data.length; _i3 >= 0; _i3--) {
      if (cumulativeSum[_i3] < cutHigh) break;
      cutRight = _i3;
    }
    return data.slice(cutLeft, cutRight + 1);
  };
  if ((0, _isArray.default)(data[0].v)) {
    var keys = (0, _sortBy.default)(_toConsumableArray(new Set(data.map(function (d) {
      return d.v.map(function (d2) {
        return d2.k;
      });
    }).reduce(function (acc, cur) {
      return acc.concat(cur);
    }, []))));
    var convertObj = convertData(data);
    var currentData = keys.map(function (k) {
      return {
        k: k,
        v: convertObj[k]
      };
    });
    var res = convertData(filterData(currentData));
    return data.map(function (_ref3) {
      var k = _ref3.k;
      return {
        k: k,
        v: k in res ? res[k] : []
      };
    });
  } else {
    return filterData(data);
  }
};
exports.removeOutlierByPercentile = removeOutlierByPercentile;